import React, { FC, useCallback } from 'react';
import { FormattedMessage } from 'react-intl';
import { TrackAddToBoardPopUpTarget, useTrackBoardAnalytics } from '../../../../utils/hooks/bi/useTrackBoardAnalytics';
import { useBoards } from '../../../../utils/hooks/useBoards';
import { ContextMenuItem } from '../../ContextMenu/ContextMenuItem';
import { Button, WixIcons } from '../../index';
import { BoardThumbnail } from '../../Thumbnails/BoardThumbnail';
import styles from '../BoardsContextMenu.scss';
import { IOuter } from './BoardListItem.types';

export const BoardListItem: FC<IOuter> = ({ board, itemsToAdd, hasItems }) => {
  const { addItems } = useBoards();
  const { trackAddToBoardMenuClick } = useTrackBoardAnalytics();

  const isAllowingToAddFilesToAllBoards = itemsToAdd.length > 1;

  const handleClick = useCallback(
    (_event, params) => {
      const clickOrigin = params.contextMenuOrigin;

      addItems([board], itemsToAdd, { clickOrigin });

      trackAddToBoardMenuClick(itemsToAdd, {
        target: TrackAddToBoardPopUpTarget.Add,
        clickOrigin,
      });
    },
    [addItems, board, itemsToAdd, trackAddToBoardMenuClick],
  );

  return (
    <ContextMenuItem
      icon={<BoardThumbnail board={board} imageClassName={styles.boardImage} width={24} height={24} />}
      title={board.name}
      titleClassName={styles.boardLabel}
      onClick={handleClick}
      hotKey={
        hasItems ? (
          !isAllowingToAddFilesToAllBoards && (
            <WixIcons.Check
              className={styles.checkMark}
              data-hook="board-has-items-check-mark"
              data-board-id={board.id}
            />
          )
        ) : (
          <Button className={styles.boardAddButton} size="tiny" dataHook="boards-context-menu-add-to-board-button">
            <FormattedMessage id="boards.context-menu.add" />
          </Button>
        )
      }
      menuItemClassName={styles.board}
      dataHook="boards.context-menu-item"
      dataMenuItemId={board.id}
      ellipsis
    />
  );
};
